export default __webpack_public_path__ + "static/media/icon-button-action.bda3ca3e.svg";